<template>
	<header-block title="" border="0" bgcolor="transparent"></header-block>
	
	<div class="simplePage">
		<img class="heroImg" src="../assets/verified.png" />
		<h1>Great job!</h1>
		<p>You've tagged all of your outgoing transactions.  Keep it up.</p>
		<div class="anchor-bottom">
			<MGButton v-if="spendAnalysisReady" text="Done" @click="$router.back()" :arrow="false"/>
			<MGButton v-else text="Loading..." :arrow="false" :disabled="true"/>
		</div>
		
	</div>

</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';

export default {
	mixins: [Services],
	components: {MGButton, HeaderBlock},
	data() {
		return {
			employer: null,
			interval: null,
			spendAnalysisReady: false,
			spendAnalysisReadyLastMonth: false,
			bankingInfoReady: false,
		}
	},
	computed: {
		type() {
			return this.$route.query.type;
		}
	},
	methods: {
		onLoad: async function() {

		}
	},
	mounted: function () {
		this.onLoad(
			setTimeout(() => {
				this.spendAnalysisReady = true;
				this._getSpendingAnalysisStructured(null, /* refreshCache: */ true);
				this._getBankingInfo(null, /*refreshCache: */ true)
			}, 2000),
		);
	}
}
</script>

<style scoped>



</style>
